import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Input,
  useDisclosure,
  Flex,
  Grid,
  Select,
  useToast,
} from '@chakra-ui/react'
import { useForm } from 'react-hook-form'
import { z } from 'zod'
import { zodResolver } from '@hookform/resolvers/zod'
import { apiBlog } from '../../../../services/api'
import { useEffect, useState } from 'react'
import { useQueryClient } from 'react-query'
import { uploadImagePost } from '../functions/uploadImagePost'
import { TextEditor } from '../../../../components/TextEditor'
const IMAGE_UPLOAD_SIZE = 100000

const schema = z.object({
  title: z.string().nonempty(),
  content: z.string().nonempty(),
  featured: z
    .string()
    .nonempty()
    .transform((value) => value === 'true'),
  // tags: z.string().nullable(),
  image: z.string().nonempty(),
  timeToRead: z
    .string()
    .nonempty()
    .transform((value) => parseInt(value)),
})

export function ModalEditPost({ userBlog, post, refetch }) {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const { handleSubmit, formState, register, control, setValue } = useForm({
    resolver: zodResolver(schema),
  })

  const [image, setImage] = useState(null)

  console.log(post.content)

  useEffect(() => {
    setValue('title', post.title)
    setValue('content', post.content)
    // setValue('featured', post.featured)
    setValue('image', post.imageUrl)
    setValue('timeToRead', post.timeToRead)
    setValue('featured', post.featured ? 'true' : 'false')
  }, [post, setValue])

  const queryClient = useQueryClient()

  const toast = useToast()

  async function handleSave(data) {
    if (!userBlog) {
      return
    }

    if (image && image.size > IMAGE_UPLOAD_SIZE) {
      toast({
        title: `Imagem maior que ${IMAGE_UPLOAD_SIZE / 1000}kb, por favor, escolha uma imagem menor`,
        status: 'error',
        duration: 3000,
        isClosable: true,
      })

      return
    }

    try {
      let urlImage = post.imageUrl

      if (image) {
        const { url } = await uploadImagePost(image)

        urlImage = url
      }

      if (!urlImage) {
        return
      }

      const response = await apiBlog.put(
        `/post/${post.id}`,
        {
          title: data.title,
          content: data.content,
          category: 'brindes',
          user_id: userBlog.id,
          image: urlImage,
          featured: data.featured,
          tags: [],
          timeToRead: data.timeToRead,
        },
        {
          headers: {
            Authorization: `Bearer ${userBlog.token}`,
          },
        }
      )

      console.log(response)

      toast({
        title: 'Post criado com sucesso',
        status: 'success',
        duration: 3000,
        isClosable: true,
      })

      queryClient.invalidateQueries('posts')
      refetch()
    } catch (error) {
      console.log(error)

      toast({
        title: 'Erro ao criar o post',
        status: 'error',
        duration: 3000,
        isClosable: true,
      })
    }
  }

  return (
    <>
      <Button onClick={onOpen} colorScheme="blue">
        Editar
      </Button>
      <Modal isOpen={isOpen} onClose={onClose} size="2xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Faça login para criar um post no blog.</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Flex flexDir="column" gap={3} maxW="1000px" mx="auto" disabled={formState.isSubmitting}>
              <Grid templateColumns="1fr 1fr" gap={3}>
                <Input placeholder="Título" {...register('title')} />
                <Select placeholder="Destaque no Blog" {...register('featured')}>
                  <option value="true">Sim</option>
                  <option value="false">Não</option>
                </Select>

                <Input type="file" onChange={(e) => setImage(e.target.files[0])} />

                <Select placeholder="Tempo de leitura" {...register('timeToRead')}>
                  <option value="5">5 minutos</option>
                  <option value="10">10 minutos</option>
                  <option value="15">15 minutos</option>
                  <option value="20">20 minutos</option>
                  <option value="25">25 minutos</option>
                  <option value="30">30 minutos</option>
                </Select>
              </Grid>

              {/* <ReactQuill theme="snow" value={value} onChange={setValue} /> */}
              <TextEditor control={control} />
            </Flex>
          </ModalBody>

          <ModalFooter mt={10}>
            <Button variant="ghost" mr={3} onClick={onClose}>
              Fechar
            </Button>
            <Button colorScheme="blue" isLoading={formState.isSubmitting} onClick={handleSubmit(handleSave)}>
              Confirmar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}
